import React, { useState } from "react";
import BjelinButton from "../../components/BjelinButton";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { PopupFragment } from "./PopupFragment";

const PopupFragmentButton = ({ title, fragment, variant }) => {
  const t = useBjelinTranslations();
  const [isOpen, setIsOpen] = useState(false);
  const _title = title ? title : t("open");
  //console.log("fragment", fragment);

  if (!fragment?._id) {
    console.warn("Unknown page fragment " + fragment?._id);
    return null;
  }

  return (
    <>
      <BjelinButton
        color={variant}
        onClick={() => setIsOpen(true)}
        className=""
      >
        {_title}
      </BjelinButton>
      <PopupFragment
        key={"fragmentPopup+" + fragment._id}
        fragmentId={fragment._id}
        show={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default PopupFragmentButton;
